import { ButtonGroup, Flex, FormControl, SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import CustomInput from "../../../components/Common/CustomInput";
import CustomSelect from "../../../components/Common/CustomInput/CustomSelect";
import IsLoading from "../../../components/Common/IsLoading";
import {
  selectButtonLoading,
  selectFormData,
  selectLoading,
} from "./redux/selector";
import { actions } from "./redux/slice";
import { StatusData } from "../Category/Create";

const Create = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectFormData);
  const loader = useSelector(selectLoading);
  const loading = useSelector(selectButtonLoading);

  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetById(params?.id));
    }
    return () => {};
  }, [params.id]);

  const handleFieldChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    dispatch(actions.updateFormValue({ key: name, value: value }));
  };
  const handleCancel = () => {
    dispatch(actions.clearFrom());
    navigate(-1);
  };
  const handleSubmit = () => {
    if (form?._id) {
      dispatch(
        actions.doUpdate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    } else {
      dispatch(
        actions.doCreate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    }
  };

  return (
    <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        {loader ? (
          <IsLoading />
        ) : (
          <FormControl>
            <SimpleGrid columns={[1, 1, 2, 3]} spacingX={5}>
              <CustomInput
                name={"title"}
                value={form?.title}
                handleChange={handleFieldChange}
                placeholder={t("common.form.enterTitle")}
                title={t("common.form.title")}
              />
              <CustomSelect
                name={"status"}
                value={form?.status}
                handleChange={handleFieldChange}
                title={t("common.form.status")}
                data={StatusData}
              />
            </SimpleGrid>
            <SimpleGrid columns={1} spacing={10}>
              <Flex flexDirection="column">
                <ButtonGroup justifyContent={"flex-end"} mt={8}>
                  <CustomButton
                    handleClick={handleCancel}
                    title={t("common.button.cancel")}
                    loading={false}
                    variant="light"
                    sx={{ marginRight: "20px" }}
                  />
                  <CustomButton
                    handleClick={handleSubmit}
                    title={t("common.button.save")}
                    loading={loading}
                    disabled={!form?.title}
                    sx={{ marginLeft: "20px" }}
                  />
                </ButtonGroup>
              </Flex>
            </SimpleGrid>
          </FormControl>
        )}
      </Card>
    </Flex>
  );
};

export default Create;
